import { CLEAR_SPINNER, SET_SPINNER } from './types';

export const setSpinner = message => ({
    type: SET_SPINNER,
});
export const clearSpinner = message => ({
    type: CLEAR_SPINNER,
});
